import React, { useState, useRef } from 'react';
import classNames from 'classnames';

const HeaderSearchInput = ({ searchAccessibilityText, searchPlaceholderText }) => {
  const [expanded, setExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  const buttonRef = useRef(null);

  const handleSearchSubmit = (evt) => {
    evt.preventDefault();
    if (expanded) {
      const url = new URL(`${window.location.origin}/searchpage`);
      url.searchParams.append("term", searchTerm);
      window.location.href = url.toString();
    } else {
      setExpanded(true);
    }
    searchInputRef.current.focus();
  }

  const handleSearchBlur = (evt) => {
    if (evt.relatedTarget !== buttonRef.current) {
      setExpanded(false);
    }
  }

  const handleSearchInputChange = (evt) => {
    setSearchTerm(evt.target.value);
  }

  return (
    <form 
      className={classNames('flex items-center transition-colors duration-300', expanded ? 'bg-[#f4f6f7]' : 'bg-transparent')}
      onSubmit={handleSearchSubmit}
    >
      <label htmlFor="globalSearch" className="sr-only">{searchAccessibilityText}</label>
      <div className={classNames('overflow-hidden transition-width duration-300', expanded ? 'w-36' : 'w-0')}>
        <input 
          ref={searchInputRef}
          onChange={handleSearchInputChange}
          onBlur={handleSearchBlur}
          type="search" 
          className="p-[12px] h-[20px] text-[14px] focus:border-none focus:outline-none border-none outline-none text-blue-600 w-[150px] !bg-[#f4f6f7]"
          name="term" 
          placeholder={searchPlaceholderText}
        />
      </div>
      <button ref={buttonRef} type="submit" className="p-0 m-0 w-5 h-5 bg-transparent text-blue-800 bg-no-repeat bg-center border-none outline-none bg-[length:16px_16px]" style={{ backgroundImage: 'url(/Static/prod/images/redesign/search.svg)' }}>
        <span className="sr-only">{searchAccessibilityText}</span>
      </button>
    </form>
  )
}

export default HeaderSearchInput;